import { enums } from "../shim/jsbridge";

const {
  NONE,
  CLOUD,
  CLOUD_FROM_PARENT,
  CLOUD_FROM_CHILD,
  TC,
  TC_FROM_PARENT,
  TC_FROM_CHILD,
  USER,
  USER_FROM_PARENT,
  USER_FROM_CHILD,
  RLCS,
  RLCS_FROM_PARENT,
  RLCS_FROM_CHILD,
  JOE,
  JOE_FROM_PARENT,
  JOE_FROM_CHILD,
  AUXILIARY,
  AUXILIARY_FROM_PARENT,
  AUXILIARY_FROM_CHILD,
  NETWORK_REFERENCES,
  NETWORK_REFERENCES_FROM_PARENT,
  NETWORK_REFERENCES_FROM_CHILD,
  PARANOID_MODE_YARA,
  PARANOID_MODE_YARA_FROM_PARENT,
  PARANOID_MODE_YARA_FROM_CHILD
} = enums.classification_sources;

const NONE_LABEL = "None";
const CLOUD_LABEL = "Spectra Intelligence";
const TC_LABEL = "Spectra Core";
const USER_LABEL = "User";
const RLCS_LABEL = "Cloud Sandbox";
const JOE_LABEL = "Joe Sandbox";
const AUXILIARY_LABEL = "Auxiliary Analysis";
const NETWORK_REFERENCES_LABEL = "Network References";
const PARANOID_MODE_YARA_LABEL = "Risk Tolerance YARA Rule";
const FROM_PARENT_LABEL = "from parent";
const FROM_CHILD_LABEL = "from child";

const labels = {
  [NONE]: NONE_LABEL,

  [CLOUD]: CLOUD_LABEL,
  [CLOUD_FROM_PARENT]: `${CLOUD_LABEL} ${FROM_PARENT_LABEL}`,
  [CLOUD_FROM_CHILD]: `${CLOUD_LABEL} ${FROM_CHILD_LABEL}`,

  [TC]: TC_LABEL,
  [TC_FROM_PARENT]: `${TC_LABEL} ${FROM_PARENT_LABEL}`,
  [TC_FROM_CHILD]: `${TC_LABEL} ${FROM_CHILD_LABEL}`,

  [USER]: USER_LABEL,
  [USER_FROM_PARENT]: `${USER_LABEL} ${FROM_PARENT_LABEL}`,
  [USER_FROM_CHILD]: `${USER_LABEL} ${FROM_CHILD_LABEL}`,

  [RLCS]: RLCS_LABEL,
  [RLCS_FROM_PARENT]: `${RLCS_LABEL} ${FROM_PARENT_LABEL}`,
  [RLCS_FROM_CHILD]: `${RLCS_LABEL} ${FROM_CHILD_LABEL}`,

  [JOE]: JOE_LABEL,
  [JOE_FROM_PARENT]: `${JOE_LABEL} ${FROM_PARENT_LABEL}`,
  [JOE_FROM_CHILD]: `${JOE_LABEL} ${FROM_CHILD_LABEL}`,

  [AUXILIARY]: AUXILIARY_LABEL,
  [AUXILIARY_FROM_PARENT]: `${AUXILIARY_LABEL} ${FROM_PARENT_LABEL}`,
  [AUXILIARY_FROM_CHILD]: `${AUXILIARY_LABEL} ${FROM_CHILD_LABEL}`,

  [NETWORK_REFERENCES]: NETWORK_REFERENCES_LABEL,
  [NETWORK_REFERENCES_FROM_PARENT]: `${NETWORK_REFERENCES_LABEL} ${FROM_PARENT_LABEL}`,
  [NETWORK_REFERENCES_FROM_CHILD]: `${NETWORK_REFERENCES_LABEL} ${FROM_CHILD_LABEL}`,

  [PARANOID_MODE_YARA]: PARANOID_MODE_YARA_LABEL,
  [PARANOID_MODE_YARA_FROM_PARENT]: `${PARANOID_MODE_YARA_LABEL} ${FROM_PARENT_LABEL}`,
  [PARANOID_MODE_YARA_FROM_CHILD]: `${PARANOID_MODE_YARA_LABEL} ${FROM_CHILD_LABEL}`
};

export const PARANOID_MODE_SOURCES = [
  RLCS,
  RLCS_FROM_PARENT,
  RLCS_FROM_CHILD,
  JOE,
  JOE_FROM_PARENT,
  JOE_FROM_CHILD,
  AUXILIARY,
  AUXILIARY_FROM_PARENT,
  AUXILIARY_FROM_CHILD,
  NETWORK_REFERENCES,
  NETWORK_REFERENCES_FROM_PARENT,
  NETWORK_REFERENCES_FROM_CHILD,
  PARANOID_MODE_YARA,
  PARANOID_MODE_YARA_FROM_PARENT,
  PARANOID_MODE_YARA_FROM_CHILD
];

const paranoidLabelAndIcons = {
  label: "Risk Tolerance",
  icon: "paranoid"
};

export const CLASSIFICATION_LABELS_AND_ICONS: Record<
  number,
  { label: string; icon: string }
> = {
  [NONE]: {
    label: "",
    icon: ""
  },
  [CLOUD]: {
    label: "Threat Intelligence",
    icon: "cloud-intelligence"
  },
  [TC]: {
    label: "Static Analysis",
    icon: "static-analysis"
  },
  [USER]: {
    label: "Local Override",
    icon: "local"
  },
  [AUXILIARY]: paranoidLabelAndIcons,
  [JOE]: paranoidLabelAndIcons,
  [RLCS]: paranoidLabelAndIcons,
  [NETWORK_REFERENCES]: paranoidLabelAndIcons,
  [PARANOID_MODE_YARA]: paranoidLabelAndIcons
};

export const isClassificationReasonExtractedFile = (source: number) =>
  (source & (2 ** 9)) !== 0;

export const isClassificationReasonGoodwareOverride = (source: number) =>
  (source & (2 ** 8)) !== 0;

export const isClassificationReasonUserOverride = (
  reason: string,
  source: number
) =>
  reason.toLowerCase() === "user classification" &&
  !isClassificationReasonExtractedFile(source) &&
  !isClassificationReasonGoodwareOverride(source);

export const isClassificationSourceTiCore = (source: number) => source === TC;

export const isClassificationSourceCloud = (source: number) => source === CLOUD;

export const isClassificationSourceLocalUser = (source: number) =>
  source === USER;

const ClassificationSource = ({ value }: { value: number }) => (
  <>{labels[value]}</>
);

export default ClassificationSource;
